import Client from './client';
import CookieHelper from '../utils/cookie';
import QUERIES from './queries';
import MUTATIONS from './mutations';

class MyAccount {
    constructor() {
        this.client = new Client();
        this.html = document.querySelector('html');
        this.bind();
        this.analytics();
        this.setIdCookie();
    }

    bind() {
        this.myAccountInteraction();
        this.html.addEventListener('history.replaceState', () => this.setIdCookie());
        this.html.addEventListener('history.pushState', () =>  this.setIdCookie());
    }

    analytics() {
        if (this.isLoggedIn()) {
            window.dataLayer?.push({ loginStatus: "LoggedIn" });
        } else {
            window.dataLayer?.push({ loginStatus: "Anonymous" });
        }
    }

    async setIdCookie() {
        if(!this.isLoggedIn()) {
            CookieHelper.remove('hfr-id');        
        } else if (!CookieHelper.has('hfr-id')) {
            try { 
                const result = await this.query('me');
                const id = result?.data?.me?.id;
                CookieHelper.set('hfr-id', id);
            } catch(e) { 
                this.error(e);    
            }            
        }
    }

    error(e) {
        if(e?.message === 'Token expired') {
            CookieHelper.remove('hfr-type');
            CookieHelper.remove('hfr-id');
        }
    }

    myAccountInteraction() {
        if (document.location.pathname.startsWith('/account/')) {
            document.addEventListener('click', (e) => {
                if (e.target?.tagName?.toUpperCase() === 'BUTTON') {
                    this.flushCache();
                }
            });
        }
    }

    flushCache() {
        sessionStorage.removeItem("apollo-cache-persist");
    }

    isLoggedIn() {
        return CookieHelper.has('hfr-type') && CookieHelper.get('hfr-type') === 'USER';
    }

    async query(queryName, options) {
        if (this.isLoggedIn()) {
            const result = await this.client.query(QUERIES[queryName], options);
            return result;
        }
    }

    async mutate(mutateName, variables, options) {
        if (this.isLoggedIn()) {
            const result = await this.client.mutate(MUTATIONS[mutateName], variables, options);
            return result;
        }
    }
}

const myAccount = new MyAccount();
window.HONDA = window.HONDA || {};
window.HONDA.MyAccount = myAccount;